import { isNotNullish } from "../../core/models";
import { calcCleanWeight } from "../product/utils";
import { ITransaction } from "./data/entities";
import { ETransactionType } from "./data/models";
import { IExpenseTransactionForm, IProductTransactionForm } from "./data/product_buy_transaction_entity";

export function isPlusTransaction(transaction: ITransaction): boolean | undefined {
  switch (transaction.type) {
    case ETransactionType.GIVE:
    case ETransactionType.EXPENSE:
      return false;
    case ETransactionType.RECIEVE:
      return true;
    case ETransactionType.PRODUCT_BUY:
    case ETransactionType.PRODUCT_SELL:
      // case ETransactionType.SALARY:
      return;
  }
}

interface IListSummary {
  amount: number;
  income: number;
  dirtyWeight: number;
  cleanWeight: number;
}

export function calcTransactionListSummary(transactionList: ITransaction[]): IListSummary {
  const summary: IListSummary = {
    amount: 0,
    income: 0,
    dirtyWeight: 0,
    cleanWeight: 0,
  };

  transactionList.forEach((t) => {
    summary.amount += t.amount;
    summary.income += t.income ?? 0;
    summary.dirtyWeight += t.dirtyWeight ?? 0;

    if (isNotNullish(t.dirtyWeight) && isNotNullish(t.wastePercent)) {
      summary.cleanWeight += calcCleanWeight({ dirtyWeight: t.dirtyWeight, wastePercent: t.wastePercent });
    }
  });

  return summary;
}

export function calcTransactionFormSummary(forms: (IProductTransactionForm | IExpenseTransactionForm)[]): number {
  let total = 0;

  forms.forEach((form) => {
    total += parseFloat(form.amount.toString());
  });

  return total;
}
